import { render, staticRenderFns } from "./FeatureGalleryButton.vue?vue&type=template&id=1a772cd2&"
import script from "./FeatureGalleryButton.vue?vue&type=script&lang=js&"
export * from "./FeatureGalleryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports